import styled from "styled-components";
import { Body } from "@streeteasy/design-system/typography";

export const FullSizeContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const Text = styled(Body)`
  margin-top: 8px;
`;
